import { Autocomplete, TextField } from '@mui/material';
import { GridFilterInputValueProps, GridFilterItem } from '@mui/x-data-grid-premium';
import { KeyboardEvent, SyntheticEvent, useRef, useState } from 'react';
import { PartialGridFilterItem } from '../../types';
interface AutocompleteInputProps
  extends GridFilterInputValueProps,
    Required<{
      options: PartialGridFilterItem[];
      getAutocompleteOption: (value: GridFilterItem) => PartialGridFilterItem;
    }> {}

export function AutocompleteInput(props: AutocompleteInputProps) {
  const { item, applyValue, options, getAutocompleteOption } = props;
  const selectedOption = getAutocompleteOption(item.value);

  const [value, setValue] = useState(selectedOption || null);
  const [inputValue, setInputValue] = useState(selectedOption?.label || null);
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const onChangeHandler = (
    event: SyntheticEvent<Element, Event>,
    newValue: PartialGridFilterItem,
  ) => {
    setValue(newValue);
    applyValue({ ...item, value: newValue?.value });
    setOpen(false);
  };
  const simulateArrowDown = (element: HTMLElement) => {
    const event = new window.KeyboardEvent('keydown', {
      key: 'ArrowDown',
      code: 'ArrowDown',
      keyCode: 40,
      which: 40,
      bubbles: true,
    });

    element.dispatchEvent(event);
  };
  const onKeyDownHandler = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      const matchedOption = options.find(
        (option) => option.label.toLowerCase() === inputValue.trim().toLowerCase(),
      );
      if (matchedOption) {
        onChangeHandler(null, matchedOption);
      } else if (inputRef.current) {
        simulateArrowDown(inputRef.current);
      }
    }
  };

  return (
    <div>
      <Autocomplete
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={value}
        options={options}
        getOptionKey={(option) => option?.value}
        getOptionLabel={(option) => option?.label}
        sx={{ all: 'unset', width: '20rem' }}
        onChange={onChangeHandler}
        onKeyDown={onKeyDownHandler}
        onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Value'
            variant='standard'
            inputRef={(el) => {
              inputRef.current = el;
            }}
          />
        )}
      />
    </div>
  );
}
